export var OVERSCAN_ROW_COUNT = 5;
export var DEFAULT_ROW_HEIGHT = 40;
export var TABLE_STYLES = {
  willChange: 'auto'
};